import React from 'react';
import { useSelector } from 'react-redux';
import styles from './Error.module.scss';

export default function Error() {
    const { error } = useSelector(state => state.auth);

    if (!error) return null;

    return <div className={styles.loginError}>*{error.reason}</div>;
}
